module.exports = __webpack_public_path__ + "img/dimension_bg_right.77b9ecd9.png";